
import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";
import access from "@/assets/data/access/access.json";
import PageHero from "@/components/UI/renewal/PageHero.vue";
import CtaSection from "@/components/UI/renewal/CtaSection.vue";
import BrandButton from "@/components/UI/renewal/BrandButton.vue";

@Component({
  components: {PageHero, CtaSection, BrandButton}
})
export default class AccessContent extends Vue {
  private addressItems: string[] = access.addressItems;
  private routeItems: string[] = access.routeItems;
  private photographItems: string[] = access.photographItems;

  // "TEL 03-6380-6396" → 表示用/リンク用に整形
  private telDisplay: string = access.tel.replace(/^TEL\s*/, "");
  private telNumber: string = access.tel.replace(/[^0-9-]/g, "");

  private googleMapsUrl =
      "https://www.google.com/maps/search/?api=1&query=" +
      encodeURIComponent("株式会社Value 東京都新宿区新宿5丁目11-30 新宿第五葉山ビル5F");

  // 「〜より徒歩2分」の徒歩時間部分をバッジ表示用に抽出する
  private walkTime(route: string): string {
    const matched = route.match(/徒歩\d+分/);
    return matched ? matched[0] : "";
  }

  // バッジ表示するため本文からは徒歩時間を取り除く
  private routeText(route: string): string {
    return route.replace(/(より)?徒歩\d+分/, "");
  }
}
